export default {
  REQUEST_STORES_BY_LOCATION: 'STORES / REQUEST_STORES_BY_LOCATION',
  REQUEST_STORES_BY_LOCATION_SUCCESS: 'STORES / REQUEST_STORES_BY_LOCATION_SUCCESS',
  REQUEST_STORES_BY_LOCATION_FAILURE: 'STORES / REQUEST_STORES_BY_LOCATION_FAILURE',

  REQUEST_ALL_STORES: 'STORES / REQUEST_ALL_STORES',
  REQUEST_ALL_STORES_SUCCESS: 'STORES / REQUEST_ALL_STORES_SUCCESS',
  REQUEST_ALL_STORES_FAILURE: 'STORES / REQUEST_ALL_STORES_FAILURE',
} as const;
